export const VX_BOTTOM_NAVIGATION_EXPERIMENT = 'vx_mobweb_bx_349_bottom_navigation_v2';

export const EXPERIMENTS = [VX_BOTTOM_NAVIGATION_EXPERIMENT];
